import { ActionTree, MutationTree } from 'vuex'
import _get from 'lodash/get'
import _map from 'lodash/map'
import instance from '../connection'

class State {
  employees: [IEmployee] | [] = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  employeeList: {key: string, title: string, description: string}[] = []
  search: string = ''
  organization: string | undefined = undefined
}

const getters = {
  //
}

const actions = <ActionTree<State, any>>{
  async getEmployees({ commit, state }) {
    let params:any = {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order,
      search: state.search
    }
    if (state.organization) {
      params.org = state.organization
    }
    return commit('updateEmployees', await instance.get('/employee', { params }))
  },
  async deleteEmployee({ dispatch }, id) {
    await instance.delete('/employee/' + id)
    return await dispatch('getEmployees')
  },
  async updateEmployee({ dispatch }, employee:any) {
    await instance.put('/employee/' + employee.id, employee)
    return await dispatch('getEmployees')
  },
  async addEmployee({ dispatch }, employee:any) {
    await instance.post('/employee', employee)
    return await dispatch('getEmployees')
  },
  async listEmployee({ commit }, org: string | null = null) {
    let params = {}
    if (org) {
      params = { org }
    }
    return commit('updateEmployeeList', await instance.get('/employee/list', { params }))
  }
}

const mutations = <MutationTree<State>>{
  updateEmployees(state, records) {
    state.employees = records.data
    state.total = records.total
    state.pagination.total = records.total
  },
  updateEmployeePagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateEmployeeSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateEmployeeList(state, list) {
    state.employeeList = _map(list, obj => ({
        key: obj.id as string,
        title: obj.id as string,
        description: obj.name as string
      })
    )
  },
  updateEmployeeSearchKey(state, search) {
    state.search = search
  },
  updateCurrentEmployeeOrg(state, organization) {
    state.organization = organization
  }
}

interface IEmployee {
  name: string
  mobile: string
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}